import { InputAdornment } from "@mui/material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { TbSearch } from "react-icons/tb";

import { CommonInput } from "../CommonInput";

export default function GlobalSearchForm({
    text,
    onChange,
    children,
}: {
    text: string;
    onChange: (text: string) => void;
    children: ReactNode;
}) {
    const { t } = useTranslation();

    return (
        <div className="sticky top-0 py-3 z-10 bg-gray-50 relative">
            <CommonInput
                onChange={(e) => onChange(e.target.value)}
                value={text}
                autoFocus
                placeholder={t("placeholders.enter", { field: "Yolcu adı veya uçuş numarası" })}
                endAdornment={
                    <InputAdornment position="end">
                        <TbSearch />
                    </InputAdornment>
                }
            ></CommonInput>
            {children}
        </div>
    );
}
